export const compensaPaymentSuccessUrl = '/zaplac/confirmation/compensa/success';
